/// <amd-module name="Search/Code/Flux/Stores/NotificationStore" />

import * as VSSStore from "VSS/Reflux/Store";
import { IResultsLoadedPayload } from "Search/Shared/Base/ActionsHub";
import { ISeedData } from "Search/Shared/Base/Types";
import { ErrorData } from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";
import { IndexingErrorCodeConstants, SearchErrorCodeConstants } from "Search/Code/Constants";
import { CodeQueryResponse, CodeResult } from "Search/LegacyWebApi/Contracts/Code";

export interface INotificationStoreState {
    indexingBannerState: IndexingBanner;

    searchQueryState: QueryState;

    fileBannerState: StaleFileBanner;
}

export enum IndexingBanner {
    AccountIndexing,

    BranchIndexing,

    None
}

export enum QueryState {
    TimedOut,

    Succeeded
}

export enum StaleFileBanner {
   StaleFile,

    None
}

export class NotificationStore extends VSSStore.Store {
    public state: INotificationStoreState;

    constructor(changedEventName: string, data?: ISeedData<CodeResult>) {
        super(changedEventName);
        this.state = data && data.responseWithActivityId ? this.getState(data.responseWithActivityId.response as CodeQueryResponse) : this.getDefaultState();
    }

    public onSearchResultsLoaded = (payload: IResultsLoadedPayload<CodeQueryResponse, CodeResult>): void => {
        this.state = this.getState(payload.response);
        this.emitChanged();
        
    }

    public onStaleBranchLoaded = (): void => {
        this.state = this.getDefaultState();
        this.state.fileBannerState = StaleFileBanner.StaleFile;
        this.emitChanged();
    }

    private getState = (response: CodeQueryResponse): INotificationStoreState => {
        let indexingBannerState = IndexingBanner.None;
        let fileBannerState = StaleFileBanner.None;
        let searchQueryState = QueryState.Succeeded;
        if (response && response.errors.length > 0) {
            const isIndexingScenario =
                this.check(response.errors, IndexingErrorCodeConstants.AccountIsBeingIndexed, IndexingErrorCodeConstants.AccountIsBeingReindexed);
            const isBranchIndexingScenario =
                this.check(response.errors, IndexingErrorCodeConstants.BranchesAreBeingIndexed);
            const isPartialResultForCodeScenario =
                this.check(response.errors, SearchErrorCodeConstants.PartialResultsDueToSearchRequestTimeout);

            if (isIndexingScenario) {
                indexingBannerState = IndexingBanner.AccountIndexing;
            } else if (isBranchIndexingScenario) {
                indexingBannerState = IndexingBanner.BranchIndexing;
            } else if (isPartialResultForCodeScenario) {
                searchQueryState = QueryState.TimedOut;
            }
        }

        return { indexingBannerState, searchQueryState, fileBannerState };
    }

    private check(errors: ErrorData[], ...args: string[]): boolean {
        return errors
            .some(e => args.some((arg: string) => e.errorCode === arg));
    }

    private getDefaultState = (): INotificationStoreState => {
        return {
            indexingBannerState: IndexingBanner.None,
            fileBannerState: StaleFileBanner.None,
            searchQueryState: QueryState.Succeeded
        };
    }
}